/* Lazy Load Initialiser */
var lazyLoadInstance = new LazyLoad({});

function scrollNextSection() {
  const viewportHeight = window.innerHeight;
  const targetPosition = window.scrollY + viewportHeight;

  window.scrollTo({
    top: targetPosition,
    behavior: "smooth",
  });
}

function scrollCheck() {
  var bannerDialog = document.querySelector(".shopify-section--announcement-bar");
  var header = document.querySelector("header");
       console.log(bannerDialog);
  if (bannerDialog && header) {
   
    if (window.scrollY <= 9) {  
      header.style.top = "40px";
    } else {
      header.style.top = "";
    }
  }
}
window.addEventListener("scroll", scrollCheck);
window.addEventListener("load", scrollCheck);
scrollCheck();



    // vanilla JS
  // init with element
  // on load
  // window.addEventListener("load", function() {
  //     var grid = document.querySelector('.masonry');
  //     var msnry = new Masonry( grid, {
  //         itemSelector: '.frame',
  //         columnWidth: "calc(33vw - 8px)",

  //     });
  // });


  function openModal(e) {
    var modal = document.querySelector('.photo_awards__section-modal');
    modal.classList.add('active');
    console.log(e)
    var image = e.dataset.image;
    var caption = e.dataset.caption;
    var name = e.dataset.name;
    var modalContent = document.querySelector('.photo_awards__section-modal-content');
    modalContent.querySelector('.photo_awards__section-modal-content-image .bg-img img').src = image;
    modalContent.querySelector('.photo_awards__section-modal-content-image .bg-img-overlay img').src = image;
    modalContent.querySelector('.photo_awards__section-modal-content-form input[name="submission_title"]').value = name;
    // modalContent.querySelector('.photo_awards__section-modal-content-form .caption').textContent = caption;


  }
  function closeModal() {
    var modal = document.querySelector('.photo_awards__section-modal');
    modal.classList.remove('active');
  }


  

// add to your JSON body:
const photoAwardForm = document.querySelector('.photo_award_form');

if (photoAwardForm) {
  const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbwENLKiaffyj1lxeAr4zvvXrKcFonLFsKSfrAYWTq6OOZtQBD83xHKsN9wMbx5KW2Oz/exec';

  const btn       = document.getElementById('submit-btn');
  const successEl = document.getElementById('success-msg');
  const errorEl   = document.getElementById('error-msg');

  const fields = {
    firstName : document.getElementById('first-name'),
    lastName  : document.getElementById('last-name'),
    email     : document.getElementById('email'),
    title     : document.getElementById('submission_title'),
    honeypot  : document.getElementById('website'),
    mailchimp : document.getElementById('mailchimp'),
  };

  function showMessage(type, text) {
    successEl.style.display = 'none';
    errorEl.style.display   = 'none';
    if (type === 'success') {
      successEl.textContent = text;
      successEl.style.display = 'block';
    } else {
      errorEl.textContent = text;
      errorEl.style.display = 'block';
    }
  }

  function setLoading(isLoading) {
    btn.disabled    = isLoading;
    btn.textContent = isLoading ? 'Submitting…' : 'Submit';
  }

  function resetForm() {
    fields.firstName.value  = '';
    fields.lastName.value   = '';
    fields.email.value      = '';
    fields.title.value      = '';
    fields.mailchimp.checked = false;
  }

  async function submitForm(e) {
    e.preventDefault();

    successEl.style.display = 'none';
    errorEl.style.display   = 'none';

    const firstName = fields.firstName.value.trim();
    const lastName  = fields.lastName.value.trim();
    const email     = fields.email.value.trim();
    const title     = fields.title.value.trim();
    const honeypot  = fields.honeypot.value.trim();
    const mailchimp = fields.mailchimp.checked;

    // Basic validation
    if (!firstName || !lastName || !email) {
      showMessage('error', '✗ Please fill in all required fields.');
      return;
    }

    // Honeypot — silently bail if filled in
    if (honeypot !== '') return;

    setLoading(true);

    try {
      const res = await fetch(SCRIPT_URL, {
        method  : 'POST',
        headers : { 'Content-Type': 'text/plain' },
        body    : JSON.stringify({ firstName, lastName, email, title, website: honeypot, mailchimp }),
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json();

      if (data.result === 'success') {
        showMessage('success', '✓ Your submission was received!');
        resetForm();
      } else if (data.result === 'duplicate') {
        showMessage('error', '✗ That email has already been submitted.');
      } else if (data.result === 'honeypot') {
        // silent
      } else {
        throw new Error(data.error || 'Unexpected response');
      }
    } catch (err) {
      console.error('Form submission error:', err);
      showMessage('error', '✗ Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  photoAwardForm.addEventListener('submit', submitForm);
}